import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Layout from './componets/Layout/Layout';
import Home from './Pages/Home';
import Courses from './Pages/Courses';
import CourseDetails from './Pages/CourseDetails';
import Profile from './Pages/Profile';
import SupervisorDashboard from './Pages/SupervisorDashboard';
import AutoCourseGeneratorPage from './Pages/AutoCourseGeneratorPage';
import AdminDashboard from './Pages/AdminDashboard';
import CourseCreator from './Pages/CourseCreator';
import CourseViewer from './Pages/CourseViewer';
import Login from './componets/Login';
import Register from './componets/Register';
import PrivateRoute from './PrivateRoute';
import EditCourse from './Pages/EditCourse';
import CursosPerfilPage from './Pages/CursosPerfilPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/courses" element={<PrivateRoute><Courses /></PrivateRoute>} />
            <Route path="/course/:id" element={<PrivateRoute><CourseDetails /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/mis-cursos" element={<CursosPerfilPage />} />
            <Route path="/supervisor-dashboard" element={<PrivateRoute><SupervisorDashboard /></PrivateRoute>} />
            <Route path="/auto-course-generator" element={<PrivateRoute><AutoCourseGeneratorPage /></PrivateRoute>} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/create-course" element={<PrivateRoute><CourseCreator /></PrivateRoute>} />
            <Route path="/course/:id/view" element={<PrivateRoute><CourseViewer /></PrivateRoute>} />
            <Route path="/course/:id/edit" element={<PrivateRoute><EditCourse /></PrivateRoute>} />
          </Routes>
        </Layout>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;